import React, { useState, useEffect, useCallback } from "react";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import LoadingIcon from "mdi-react/LoadingIcon";
import DataTable from "react-data-table-component";

import {
  reelsConstants,
  eventsConstants,
  configurationsConstants,
} from "../../constants";
import { reelsActions } from "../../redux/actions";
import PaginationComponent from "../../shared/components/PaginationComponent/PaginationComponent";

const { RECAP_FEEDBACK_STATUS, GALLERY_ACTION_TYPES } = reelsConstants;

const RecapFeedback = (props) => {
  const spinner = useCallback(
    (type) => props.spinnerActions.findIndex((f) => f === type),
    [props.spinnerActions]
  );
  const { GET_RECAP_FEEDBACK } = reelsConstants;
  const { t } = useTranslation("common");

  const [expandedCard, setExpandedCard] = useState(null);
  const [expandedSubCard, setExpandedSubCard] = useState(null);
  const [pagination, setPagination] = useState({
    pageSize: configurationsConstants.DEFAULT_PAGINATION_PAGE_SIZE,
    pageNumber: 1,
    totalRows: 0,
  });
  const [activeTab, setActiveTab] = useState(RECAP_FEEDBACK_STATUS.PENDING);

  useEffect(() => {
    if (activeTab) {
      props.getRecapFeedback(
        pagination.pageSize,
        pagination.pageNumber,
        activeTab
      );
    }
    // eslint-disable-next-line
  }, [activeTab]);

  useEffect(() => {
    setPagination({
      pageSize: props.recapFeedback?.pageSize,
      pageNumber: props.recapFeedback?.currentPage,
      totalRows: props.recapFeedback?.total,
    });
  }, [props.recapFeedback]);

  const handleCollapseToggle = (cardId) => {
    setExpandedCard(cardId === expandedCard ? null : cardId);
  };

  const handleSubCollapseToggle = (cardId) => {
    setExpandedSubCard(cardId === expandedSubCard ? null : cardId);
  };

  const getGalleryChangeFields = (gallery) => {
    const actionTypeLabel = GALLERY_ACTION_TYPES[gallery.actionType] || "";
    const isDelete = actionTypeLabel.toLowerCase() === GALLERY_ACTION_TYPES[2];
    const isSongFeedback =
      actionTypeLabel.toLowerCase() === GALLERY_ACTION_TYPES[4];
    const isSimpleFeedback =
      actionTypeLabel.toLowerCase() === GALLERY_ACTION_TYPES[5];

    const fields = [];

    if (!isSimpleFeedback) {
      fields.push({
        label: t("action_type"),
        value: actionTypeLabel,
      });
    }

    if (!isSongFeedback && !isSimpleFeedback) {
      fields.push({
        label: t("time_requested"),
        value: gallery.timeRequested,
      });
    }

    if (!isDelete && !isSongFeedback && !isSimpleFeedback) {
      fields.push({
        label: t("file_name"),
        value: gallery.filename,
      });
    }

    if (isSongFeedback || isSimpleFeedback) {
      fields.push({
        label: t("feedback"),
        value: gallery.feedback,
      });
    }

    return fields;
  };

  const columns = [
    {
      width: "100%",
      cell: (row) => {
        return (
          <React.Fragment key={row.eventGroupId}>
            <div className="card card-style pagination-card-width mb-2">
              <div className="card-header back-color">
                <p className="mb-0">
                  <a
                    href={`#${row.eventGroupId}`}
                    className="collapsed d-flex justify-content-between a-style"
                    onClick={() => handleCollapseToggle(row.eventGroupId)}
                  >
                    <div className="p-0 m-0">
                      {row?.eventGroupName ??
                        eventsConstants.EVENT_GROUP_NAME_NOT_AVAILABLE}
                    </div>
                    <strong>{t("group_Id") + row.eventGroupId}</strong>
                  </a>
                </p>
              </div>
              <div
                id={`collapse${row.eventGroupId}`}
                className={`collapse ${
                  expandedCard === row.eventGroupId ? "show" : ""
                }`}
              >
                <div className="card-body">
                  {row?.subEvents && row?.subEvents?.length > 0 ? (
                    <>
                      {row.subEvents.map((subEvents) => {
                        return subEvents?.recaps?.map((item, index) => {
                          const recapUrl = `${process.env.REACT_APP_S3_BASE_URL_EVENTS_GALLERY}/${item.url}`;

                          return (
                            <div className="card card-style pagination-card-width mb-2 w-100">
                              <div className="card-header back-color">
                                <p className="mb-0">
                                  <a
                                    href={`#${item.id}`}
                                    className="collapsed d-flex justify-content-between a-style"
                                    onClick={() =>
                                      handleSubCollapseToggle(item.id)
                                    }
                                  >
                                    <div className="p-0 m-0">
                                      {subEvents?.reelName ??
                                        eventsConstants.EVENT_NAME_NOT_AVAILABLE}
                                    </div>
                                    <strong>
                                      {" "}
                                      {`${t("event_Id")} ${
                                        item.eventId ?? subEvents?.id
                                      }`}
                                    </strong>
                                  </a>
                                </p>
                              </div>
                              <div
                                id={`collapse${item.id}`}
                                className={`collapse ${
                                  expandedSubCard === item.id ? "show" : ""
                                }`}
                              >
                                <div className="card-body">
                                  {item?.galleryChanges?.length > 0 &&
                                    item.galleryChanges.map(
                                      (gallery, galleryIndex) => {
                                        const fields =
                                          getGalleryChangeFields(gallery);

                                        return (
                                          <React.Fragment key={galleryIndex}>
                                            {fields.map(({ label, value }) => (
                                              <div
                                                className="d-flex"
                                                key={label}
                                              >
                                                <p className="text-left w-25 fw-bold">
                                                  {label}
                                                </p>
                                                <p className="w-75">{value}</p>
                                              </div>
                                            ))}
                                            <hr className="mt-1 mb-3 border-top border-secondary-subtle" />
                                          </React.Fragment>
                                        );
                                      }
                                    )}

                                  <div className="d-flex">
                                    <p className="text-left w-25 fw-bold">
                                      URL
                                    </p>
                                    <p className="w-75">
                                      <a
                                        href={recapUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-decoration-underline"
                                      >
                                        {item.url}
                                      </a>
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        });
                      })}
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            </div>
          </React.Fragment>
        );
      },
      allowOverflow: true,
      button: true,
    },
  ];
  const customStyles = {
    headCells: {
      style: {
        fontWeight: "bold",
      },
    },
    rows: {
      style: {
        "&:not(:last-of-type)": {
          borderBottomWidth: "0px",
        },
      },
    },
  };

  return (
    <div className="row mr-0">
      <div className="col-md-12">
        <div className="col-lg-12">
          <ul className="nav nav-tabs">
            {[
              RECAP_FEEDBACK_STATUS.PENDING,
              RECAP_FEEDBACK_STATUS.COMPLETED,
            ].map((tabKey) => (
              <li className="nav-item" key={tabKey}>
                <button
                  className={`nav-link ${activeTab === tabKey ? "active" : ""}`}
                  onClick={() => setActiveTab(tabKey)}
                >
                  {tabKey.charAt(0).toUpperCase() + tabKey.slice(1)}
                </button>
              </li>
            ))}
          </ul>

          <div className="tab-content">
            <div className="tab-pane fade show active">
              {spinner(GET_RECAP_FEEDBACK) ? (
                <div>
                  <PaginationComponent
                    pagination={pagination}
                    setPagination={setPagination}
                    getTableData={props.getRecapFeedback}
                    status={activeTab}
                  />
                  <DataTable
                    columns={columns}
                    data={props.recapFeedback?.items}
                    responsive
                    customStyles={customStyles}
                    className="no-scroll"
                  />
                </div>
              ) : (
                <div className="text-center mt-4">
                  <LoadingIcon className="loading-spinner" />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  recapFeedback: state.reels.recapFeedback,
  spinnerActions: state.system.spinnerActions,
});

// Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  getRecapFeedback: (pageSize, pageNumber, status) =>
    dispatch(reelsActions.getRecapFeedback(pageSize, pageNumber, status)),
});

// Mapping action and store the function via props
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(RecapFeedback));
